import superagent from 'superagent'

export const USER_SUBSCRIPTION_FETCH = 'USER_SUBSCRIPTION_FETCH'
export const USER_SUBSCRIPTION_CREATE = 'USER_SUBSCRIPTION_CREATE'
export const USER_SUBSCRIPTION_UPDATE = 'USER_SUBSCRIPTION_UPDATE'
export const USER_SUBSCRIPTION_UPDATE_LS = 'USER_SUBSCRIPTION_UPDATE_LS'
export const USER_SUBSCRIPTION_CHANGES = 'USER_SUBSCRIPTION_CHANGES'
export const USER_SUBSCRIPTION_CHANGES_LS = 'USER_SUBSCRIPTION_CHANGES_LS'

export const userSubscriptionFetch = userSubscription => {
  return {
    type: USER_SUBSCRIPTION_FETCH,
    payload: userSubscription
  }
}

export const userSubscriptionCreate = userSubscription => {
  return {
    type: USER_SUBSCRIPTION_CREATE,
    payload: userSubscription
  }
}

export const userSubscriptionUpdate = userSubscription => {
  return {
    type: USER_SUBSCRIPTION_UPDATE,
    payload: userSubscription
  }
}

export const userSubscriptionUpdateLS = userSubscription => {
  return {
    type: USER_SUBSCRIPTION_UPDATE_LS,
    payload: userSubscription
  }
}

export const userSubscriptionChanges = userSubscription => {
  return {
    type: USER_SUBSCRIPTION_CHANGES,
    payload: userSubscription
  }
}

export const userSubscriptionChangesLS = userSubscription => {
  return {
    type: USER_SUBSCRIPTION_CHANGES_LS,
    payload: userSubscription
  }
}

// export const userSubscriptionFetchRequest = () => (dispatch, getState, token) => {
//   return new Promise(resolve => {
//     superagent
//       .get(`${__API_URI__}/UserSubscription/Get`)
//       .set('Authorization', `Bearer ${token}`)
//       .set('Content-Type', 'application/json')
//       .set('Platform', 'Web')
//       .set('Version', `${__version__}`)
//       .end((err, res) => {
//         if (err) {
//           if (err.status == 401) {
//             resolve(err.status)
//           }
//         }
//         const userSubscription = res.body
//         dispatch(userSubscriptionFetch(userSubscription))
//       })
//   })
// }

export const userSubscriptionFetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/UserSubscription/Get`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status === 401) {
            resolve(err.status);
          }
          return; // 🔴 stop here, res is undefined
        }

        const userSubscription = res?.body || {};
        dispatch(userSubscriptionFetch(userSubscription));
        resolve(userSubscription);
      });
  });
};


export const userSubscriptionCreateRequest = UserObj => (dispatch, getState) => {
  return new Promise(resolve => {
    superagent
      .post(`${__API_URI__}/UserSubscription/Create`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(UserObj))
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            resolve(err.status)
          }
        }
        dispatch(userSubscriptionCreate(res.body))
      })
  })
}

export const userSubscriptionUpdateRequest = UserObj => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .put(`${__API_URI__}/UserSubscription/Update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(UserObj))
      .end((err, res) => {
        if (err) {
          if (err.status == 400) {
            resolve(err.status)
          }
        }
        dispatch(userSubscriptionUpdate(res.body))
      })
  })
}

export const userSubscriptionUpdateLocalStore = userSubscriptionObject => (dispatch, getState, token) => {
  const userSubscriptionLatest = userSubscriptionObject.reduce(function (prev, current) {
    return prev.subscriptionPlanId > current.subscriptionPlanId ? prev : current
  })
  //const userSubscriptionObject =userSubscriptionData
  //localStorage.setItem('userSubscriptionLS',null)
  //let newUserSubscriptionLS = userSubscriptionObject
  let currentUserSubscription = JSON.parse(localStorage.getItem('userSubscriptionLS'))
  if (currentUserSubscription !== userSubscriptionLatest) {
    currentUserSubscription = userSubscriptionLatest
  }
  // const currentUserSubscription = currentUserSubscriptionLS.reduce(function(prev, current) {
  //   return prev.subscriptionPlanId > current.subscriptionPlanId ? prev : current
  // })

  // let newUserSubscriptionLS = {
  //   userId:
  // 		userSubscriptionObject.userId !== currentUserSubscription.userId
  // 		  ? userSubscriptionObject.userId
  // 		  : currentUserSubscription.userId,
  //   subscriptionPlanId:
  // 		userSubscriptionObject.subscriptionPlanId > currentUserSubscription.subscriptionPlanId
  // 		  ? userSubscriptionObject.subscriptionPlanId
  // 		  : currentUserSubscription.subscriptionPlanId,
  //   subscriptionPlanDurationId:
  // 		userSubscriptionObject.subscriptionPlanDurationId !== currentUserSubscription.subscriptionPlanDurationId &&
  // 		userSubscriptionObject.subscriptionPlanId > currentUserSubscription.subscriptionPlanId
  // 		  ? userSubscriptionObject.subscriptionPlanDurationId
  // 		  : currentUserSubscription.subscriptionPlanDurationId,
  //   effDate: userSubscriptionObject.effDate,
  //   expDate: userSubscriptionObject.effDate,
  //   created: userSubscriptionObject.created,
  //   updated:
  // 		userSubscriptionObject.updated !== currentUserSubscription.updated &&
  // 		userSubscriptionObject.subscriptionPlanId > currentUserSubscription.subscriptionPlanId
  // 		  ? new Date().toISOString()
  // 		  : currentUserSubscription.updated,
  //   receiptId: userSubscriptionObject.receiptId ? userSubscriptionObject.receiptId : 0,
  //   platformId: userSubscriptionObject.platformId,
  //   paymentId:
  // 		userSubscriptionObject.paymentId !== currentUserSubscription.paymentId
  // 		  ? userSubscriptionObject.paymentId
  // 		  : currentUserSubscription.paymentId,
  //   cancelDate:
  // 		userSubscriptionObject.cancelDate !== currentUserSubscription.cancelDate
  // 		  ? new Date().toISOString()
  // 		  : userSubscriptionObject.cancelDate,
  //   platformCode:
  // 		userSubscriptionObject.platformCode !== currentUserSubscription.platformCode
  // 		  ? 'no-code'
  // 		  : userSubscriptionObject.platformCode,
  //   id:
  // 		userSubscriptionObject.id !== currentUserSubscription.id ? userSubscriptionObject.id : currentUserSubscription.id
  // }
  // //}

  localStorage.setItem('userSubscriptionLS', JSON.stringify(currentUserSubscription))

  return dispatch(userSubscriptionUpdateLS(currentUserSubscription))
}

export const userSubscriptionChangesLocalStore = () => (dispatch, getState, token) => {
  const currentSubscriptionLS = JSON.parse(localStorage.getItem('userSubscriptionLS'))

  return dispatch(userSubscriptionChangesLS(currentSubscriptionLS))
}

export const userSubscriptionChangesRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/UserSubscription/Changes`) //?asOfDate=${asOfDate.toISOString()}&toDate=${toDate.toISOString()}
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            resolve(err.status)
          }
        }
        const userSubscription = res.body
        resolve(userSubscription)
        dispatch(userSubscriptionChanges(userSubscription))
      })
  })
}
